import React from 'react';

function EmbedPreview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(-668 -1228)">
          <g transform="translate(531 1175)">
            <g transform="translate(137 53)">
              <path fill="#FFF" d="M0 0H108V108H0z" />
              <path
                fill="#EFEFEF"
                d="M93 99a4 4 0 014 4v5H10v-5a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79z"
              />
              <path
                fill="currentColor"
                d="M93 11a4 4 0 014 4v41a4 4 0 01-4 4H14a4 4 0 01-4-4V15a4 4 0 014-4h79zM47.55 27a1.251 1.251 0 00-.66.18 1.21 1.21 0 00-.587.864l-.045.554-.076.766-.032.417-.027.482-.024.546-.02.611c-.004.107-.006.217-.009.33A78.62 78.62 0 0046 35c0 .78.013 1.586.04 2.419l.044 1.173.056 1.16.042.697.057.731.056.612.005.038c.006.417.235.799.6 1 .199.12.428.183.66.18.152-.012.3-.05.44-.11A46.15 46.15 0 0059.56 36a1.22 1.22 0 00.44-1 1.12 1.12 0 00-.44-.94l-.052-.05-.146-.13-.319-.263-.24-.19-.397-.3-.922-.675-.224-.162a52.033 52.033 0 00-2.45-1.66 44.688 44.688 0 00-3.13-1.81A37.967 37.967 0 0048 27.1a1.384 1.384 0 00-.45-.1z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default EmbedPreview;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/EmbedMultimediaPreview.js